import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-6">
      <div className="bg-white border border-gray-200 rounded-sm p-8 max-w-md w-full" data-testid="payment-cancel-page">
        <h1 className="font-heading text-xl font-bold text-[#16324F] mb-2">Checkout cancelled</h1>
        <p className="text-sm text-ink-muted mb-6">No charge was made. You can restart the upgrade at any time.</p>
        <Link to="/billing" data-testid="cancel-back-to-billing-link"
          className="inline-block bg-[#16324F] text-white rounded-sm px-4 py-2 text-sm hover:bg-[#10243a] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#16324F] focus-visible:ring-offset-2">
          Back to billing
        </Link>
      </div>
    </div>
  );
}
